function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMarkCircle = function SvgQuestionMarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 19c5 0 9-4 9-9s-4-9-9-9-9 4-9 9 4 9 9 9zm.9-8.1v1.4H8.8v-3h.5c1.3 0 2.1-.7 2.1-1.8s-.6-1.6-1.5-1.6c-.9.1-1.6.9-1.6 1.9H6C6 5.7 7.6 4 9.9 4s3.9 1.2 3.9 3.5c0 1.9-1.2 3.2-2.9 3.4zm.3 3.7c0 .8-.6 1.4-1.3 1.4-.8 0-1.3-.6-1.3-1.4 0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgQuestionMarkCircle;